import { createAndFireEvent } from '@atlaskit/analytics-next';
import { ANALYTICS_MEDIA_CHANNEL } from '@atlaskit/media-common';
// can be called in a component whose props extend WithAnalyticsEventsProps
export function fireAnalyticsEvent(payload, createAnalyticsEvent) {
  if (createAnalyticsEvent) {
    var event = createAnalyticsEvent(payload);
    event.fire(ANALYTICS_MEDIA_CHANNEL);
  }
}

// can be used inside withAnalyticsEvents() hook
export var createAndFireMediaCustomMediaPlayerEvent = function createAndFireMediaCustomMediaPlayerEvent(payload) {
  return createAndFireEvent(ANALYTICS_MEDIA_CHANNEL)(payload);
};